import React, { CSSProperties } from 'react'
import { Checkbox, Divider } from '@blueprintjs/core'
import {
  Popover,
  EmployeeSelect,
  DepartmentSelect,
  LocationSelect,
  HRLocationSelect,
  EmployeeTypeSelect,
  RoleSelect,
  TitleSelect,
  Flex,
} from '@ui'
import { Filters } from './hooks/useEmployees'
import { ValueFilter } from '@api/employee/types'
import { get, without } from 'lodash'
import track, { RootEvent } from '@track'
import Event from '@track/Event'
import { FilterButton } from '@ui'
import { IFloor, IBuilding } from '@api'

interface FiltersProps {
  filterCount: number
  filters: Filters
  applyFilters: (filters: Filters) => void
  style?: CSSProperties
  targetStyle?: CSSProperties
}

export default function FiltersComponent({
  filterCount,
  filters,
  applyFilters,
  style,
  targetStyle,
}: FiltersProps) {
  const updateFilter = (filter: Partial<Filters['filters']>) => {
    applyFilters({
      ...filters,
      filters: {
        ...filters.filters,
        ...filter,
      },
    })
  }

  return (
    <Popover
      hasBackdrop
      content={
        <div style={{ minWidth: 200, padding: 10, ...style }} onClick={(e) => e.stopPropagation()}>
          <Flex>
            <table style={{ marginRight: 24, marginTop: 7 }}>
              <tbody>
                <tr>
                  <td style={{ height: 30 }}>
                    <div style={{ padding: 'auto 0' }}>
                      <Checkbox
                        checked={filters.valueFilter.indexOf(ValueFilter.SEATED) >= 0}
                        onChange={() => {
                          applyFilters({
                            ...filters,
                            valueFilter:
                              filters.valueFilter.indexOf(ValueFilter.SEATED) >= 0
                                ? without(filters.valueFilter, ValueFilter.SEATED)
                                : [...filters.valueFilter, ValueFilter.SEATED],
                          })

                          const payload: RootEvent =
                            filters.valueFilter.indexOf(ValueFilter.SEATED) >= 0
                              ? {
                                  eventName: Event.CLEAR_FILTER,
                                  props: {
                                    filterName: 'Seated',
                                    filterValue: null,
                                  },
                                }
                              : {
                                  eventName: Event.FILTER,
                                  props: {
                                    filterName: 'Seated',
                                    filterValue: true,
                                  },
                                }

                          track.employees(payload)
                        }}
                      >
                        Seated
                      </Checkbox>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ height: 30 }}>
                    <div style={{ padding: 'auto 0' }}>
                      <Checkbox
                        checked={filters.valueFilter.indexOf(ValueFilter.UNSEATED) >= 0}
                        onChange={() => {
                          applyFilters({
                            ...filters,
                            valueFilter:
                              filters.valueFilter.indexOf(ValueFilter.UNSEATED) >= 0
                                ? without(filters.valueFilter, ValueFilter.UNSEATED)
                                : [...filters.valueFilter, ValueFilter.UNSEATED],
                          })

                          const payload: RootEvent =
                            filters.valueFilter.indexOf(ValueFilter.UNSEATED) >= 0
                              ? {
                                  eventName: Event.CLEAR_FILTER,
                                  props: {
                                    filterName: 'Unseated',
                                    filterValue: null,
                                  },
                                }
                              : {
                                  eventName: Event.FILTER,
                                  props: {
                                    filterName: 'Unseated',
                                    filterValue: true,
                                  },
                                }

                          track.employees(payload)
                        }}
                      >
                        Unseated
                      </Checkbox>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ height: 30 }}>
                    <div style={{ padding: 'auto 0' }}>
                      <Checkbox
                        checked={filters.valueFilter.indexOf(ValueFilter.REMOTE) >= 0}
                        onChange={() => {
                          applyFilters({
                            ...filters,
                            valueFilter:
                              filters.valueFilter.indexOf(ValueFilter.REMOTE) >= 0
                                ? without(filters.valueFilter, ValueFilter.REMOTE)
                                : [...filters.valueFilter, ValueFilter.REMOTE],
                          })

                          const payload: RootEvent =
                            filters.valueFilter.indexOf(ValueFilter.REMOTE) >= 0
                              ? {
                                  eventName: Event.CLEAR_FILTER,
                                  props: {
                                    filterName: 'Remote',
                                    filterValue: null,
                                  },
                                }
                              : {
                                  eventName: Event.FILTER,
                                  props: {
                                    filterName: 'Remote',
                                    filterValue: true,
                                  },
                                }

                          track.employees(payload)
                        }}
                      >
                        Remote
                      </Checkbox>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ height: 30 }}>
                    <div style={{ padding: 'auto 0' }}>
                      <Checkbox
                        checked={filters.valueFilter.indexOf(ValueFilter.NO_DESK_NEEDED) >= 0}
                        onChange={() => {
                          applyFilters({
                            ...filters,
                            valueFilter:
                              filters.valueFilter.indexOf(ValueFilter.NO_DESK_NEEDED) >= 0
                                ? without(filters.valueFilter, ValueFilter.NO_DESK_NEEDED)
                                : [...filters.valueFilter, ValueFilter.NO_DESK_NEEDED],
                          })

                          const payload: RootEvent =
                            filters.valueFilter.indexOf(ValueFilter.NO_DESK_NEEDED) >= 0
                              ? {
                                  eventName: Event.CLEAR_FILTER,
                                  props: {
                                    filterName: 'No Desk Needed',
                                    filterValue: null,
                                  },
                                }
                              : {
                                  eventName: Event.FILTER,
                                  props: {
                                    filterName: 'No Desk Needed',
                                    filterValue: true,
                                  },
                                }

                          track.employees(payload)
                        }}
                      >
                        No Desk Needed
                      </Checkbox>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ height: 30 }}>
                    <div style={{ padding: 'auto 0' }}>
                      <Checkbox
                        checked={filters.valueFilter.indexOf(ValueFilter.MANUAL) >= 0}
                        onChange={() => {
                          applyFilters({
                            ...filters,
                            valueFilter:
                              filters.valueFilter.indexOf(ValueFilter.MANUAL) >= 0
                                ? without(filters.valueFilter, ValueFilter.MANUAL)
                                : [...filters.valueFilter, ValueFilter.MANUAL],
                          })

                          const payload: RootEvent =
                            filters.valueFilter.indexOf(ValueFilter.MANUAL) >= 0
                              ? {
                                  eventName: Event.CLEAR_FILTER,
                                  props: {
                                    filterName: 'Manual',
                                    filterValue: null,
                                  },
                                }
                              : {
                                  eventName: Event.FILTER,
                                  props: {
                                    filterName: 'Manual',
                                    filterValue: true,
                                  },
                                }

                          track.employees(payload)
                        }}
                      >
                        Manually Added
                      </Checkbox>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Divider />
            <div style={{ marginLeft: 24 }}>
              <table style={{ minWidth: 190 }}>
                <tbody>
                  <tr>
                    <td style={{ height: 45 }}>HR Location</td>
                    <td>
                      <HRLocationSelect
                        clearable
                        searchBoxPlaceholder="Search..."
                        value={filters.filters.geoLocation}
                        onChange={(geoLocation) => {
                          updateFilter({ geoLocation })

                          track.employees({
                            eventName: geoLocation ? Event.FILTER : Event.CLEAR_FILTER,
                            props: {
                              filterName: 'HR Location',
                              filterValue: geoLocation ? geoLocation.id : null,
                            },
                          })
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ height: 45 }}>
                      <div>Buildings/</div> Floors
                    </td>
                    <td>
                      <LocationSelect
                        includeOldBuildings
                        clearable
                        mode={LocationSelect.Mode.SINGLE_BUILDING_FLOOR}
                        onChange={(item: IFloor | IBuilding | null) => {
                          let floor = null
                          let building = null

                          if (item) {
                            if ('city' in item) {
                              building = item
                            } else {
                              floor = item
                            }
                          }

                          applyFilters({
                            ...filters,
                            filters: {
                              ...filters.filters,
                              floor,
                              building,
                            },
                          })

                          const payload: RootEvent = floor
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Location',
                                  filterValue: floor.id,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Location',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                        buttonProps={{ iconName: '', 'data-button': 'button-select-location' }}
                        value={
                          get(filters, 'filters.floor.id', null) ||
                          get(filters, 'filters.building.id', null)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ height: 45 }}>Manager</td>
                    <td>
                      <EmployeeSelect
                        clearable
                        value={filters.filters.manager}
                        buttonProps={{ iconName: '', 'data-button': 'button-select-employee' }}
                        onChange={(manager) => {
                          applyFilters({
                            ...filters,
                            filters: {
                              ...filters.filters,
                              manager,
                            },
                          })

                          const payload: RootEvent = manager
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Manager',
                                  filterValue: manager.id,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Manager',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                      />
                    </td>
                  </tr>
                  <tr style={{ height: 45 }}>
                    <td>Department</td>
                    <td>
                      <DepartmentSelect
                        clearable
                        value={filters.keyValueFilters.department}
                        buttonProps={{ 'data-button': 'button-select-department' }}
                        onChange={(department) => {
                          applyFilters({
                            ...filters,
                            keyValueFilters: {
                              ...filters.keyValueFilters,
                              department,
                            },
                          })

                          const payload: RootEvent = department
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Department',
                                  filterValue: department.id,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Department',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                      />
                    </td>
                  </tr>
                  <tr style={{ height: 45 }}>
                    <td>Type</td>
                    <td>
                      <EmployeeTypeSelect
                        clearable
                        buttonProps={{ 'data-button': 'button-select-employee-type' }}
                        value={filters.filters.type}
                        onChange={(type) => {
                          applyFilters({
                            ...filters,
                            filters: {
                              ...filters.filters,
                              type,
                            },
                          })

                          const payload: RootEvent = type
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Type',
                                  filterValue: type,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Type',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                      />
                    </td>
                  </tr>
                  <tr style={{ height: 45 }}>
                    <td>Role</td>
                    <td>
                      <RoleSelect
                        clearable
                        buttonProps={{ 'data-button': 'button-select-role' }}
                        value={filters.filters.role}
                        onChange={(role) => {
                          applyFilters({
                            ...filters,
                            filters: {
                              ...filters.filters,
                              role,
                            },
                          })

                          const payload: RootEvent = role
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Role',
                                  filterValue: role,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Role',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                      />
                    </td>
                  </tr>
                  <tr style={{ height: 45 }}>
                    <td>Title</td>
                    <td>
                      <TitleSelect
                        clearable
                        buttonProps={{ 'data-button': 'button-select-title' }}
                        value={filters.filters.title}
                        onChange={(title) => {
                          applyFilters({
                            ...filters,
                            filters: {
                              ...filters.filters,
                              title,
                            },
                          })

                          const payload: RootEvent = title
                            ? {
                                eventName: Event.FILTER,
                                props: {
                                  filterName: 'Title',
                                  filterValue: title,
                                },
                              }
                            : {
                                eventName: Event.CLEAR_FILTER,
                                props: {
                                  filterName: 'Title',
                                  filterValue: null,
                                },
                              }

                          track.employees(payload)
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Flex>
        </div>
      }
    >
      <FilterButton style={{ ...targetStyle }} filterCount={filterCount} />
    </Popover>
  )
}
